import { useEffect, useState } from 'react';
import CrudTable from '../../components/CrudTable';
import { db, supabase } from '../../lib/supabase';
import { useAuth } from '../../lib/useAuth';

const SHIFT_TYPES = [
  { value: 'morning', label: '🌅 Sáng (8h–14h)' },
  { value: 'afternoon', label: '☀️ Chiều (14h–20h)' },
  { value: 'evening', label: '🌙 Tối (16h–22h)' },
  { value: 'full', label: '🕐 Cả ngày' },
];
const STATUS = [
  { value: 'registered', label: '📝 Đã đăng ký' },
  { value: 'approved', label: '✅ Đã duyệt' },
  { value: 'rejected', label: '✖ Từ chối' },
];

// QT#6: nhân viên đăng ký lịch làm việc, quản lý duyệt.
export default function ShiftsAdmin() {
  const { session, role } = useAuth();
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    supabase.from('user_profiles').select('user_id, full_name, role')
      .in('role', ['staff', 'admin'])
      .then(({ data }) => setStaff(data || []));
  }, []);

  const staffOpts = staff.map((s) => ({ value: s.user_id, label: s.full_name || s.user_id.slice(0, 8) }));
  const nameOf = (id) => staff.find((s) => s.user_id === id)?.full_name || (id || '').slice(0, 8);

  return (
    <CrudTable
      title="🗓️ Đăng ký lịch làm việc"
      table="work_shifts"
      orderBy="shift_date"
      ascending={false}
      defaults={{
        staff_id: session?.user?.id,
        shift_date: new Date().toISOString().slice(0, 10),
        shift_type: 'morning',
        status: 'registered',
      }}
      columns={[
        { key: 'staff_id', label: 'Nhân viên', type: 'select', required: true,
          options: staffOpts.length ? staffOpts : (session ? [{ value: session.user.id, label: 'Tôi' }] : []),
          render: (r) => nameOf(r.staff_id) },
        { key: 'shift_date', label: 'Ngày', type: 'date', required: true },
        { key: 'shift_type', label: 'Ca', type: 'select', options: SHIFT_TYPES, required: true },
        { key: 'status', label: 'Trạng thái', type: 'select', options: STATUS },
        { key: 'note', label: 'Ghi chú', type: 'text', inTable: false },
      ]}
      rowActions={(row, reload) =>
        role === 'admin' && row.status === 'registered' ? (
          <button
            className="btn btn-primary btn-sm" title="Duyệt ca"
            onClick={async () => { await db.update('work_shifts', row.id, { status: 'approved' }); reload(); }}
          >✅</button>
        ) : null
      }
      emptyText="Chưa có ca nào được đăng ký tuần này."
    />
  );
}
